// utils/getActiveLocale.ts
import { Locale } from '@/interfaces/Locale'
import { usePathname } from 'next/navigation'

export const getActiveLocale = (): Locale => {
  const pathname = usePathname()

  // Extract the active locale from the current URL
  const getLocale = (): Locale => {
    const segments = pathname?.split('/') || []
    return segments[1] as Locale
  }

  const activeLocale = getLocale()

  return activeLocale
}
